export enum BroadcastNotificationScopeTypes {
  System = 1,
  Game = 2
}
